module.exports = __webpack_public_path__ + "assets/EquilateralByCentroid2P.986de13d57b191a5d566e3eb48e45928.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/EquilateralByCentroid2P.gmt
// module id = 943
// module chunks = 0